<template>
  <div>
    <div v-if="mx_is || isProAnnualBilledMonthlyToMonthlyDowngrade" class="opc-prorated-summary">
      <NextCharge :disable-trigger-preview='true' :ext-loading='mx_loading' :showPendingPlanSummary="isProAnnualBilledMonthlyToMonthlyDowngrade">
        <div slot="header">
          <div class="opc-cart__main__divider"></div>
          <div class="opc-cart-item__sub-title">{{ $t('billing.prorated.updated_summary') }}</div>
        </div>
      </NextCharge>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import mx from './mx.vue';
import NextCharge from "../next.vue";
import proAnnualBilledMonthlyMixin from '@/plans/ZOOM_MEETING/mixin/pro-annual-billed-monthly';

export default {
  mixins: [mx, proAnnualBilledMonthlyMixin],
  components: {
    NextCharge
  },
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-prorated-summary{
  .opc-cart-item__sub-title{
    font-size: 16px;
    margin-bottom: 12px;
    @include media(mobile, tablet) {
      font-weight: 600;
      line-height: 1.2;
      font-size: 16px;
    }
  }
  .opc-cart__next__title{
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2;
  }
}
</style>
